import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule, MenuIcon, SearchIcon } from 'lucide-angular';
import { UserMenuComponent } from '../../auth/user-menu/user-menu';
import { GarageDropdownComponent } from '../garage-dropdown/garage-dropdown';
import { SearchBarComponent } from '../search-bar/search-bar';
import { CartMiniComponent } from '../../cart/cart-mini';

@Component({
  selector: 'allas-mobile-header',

  imports: [
    CommonModule,
    LucideAngularModule,
    UserMenuComponent,
    GarageDropdownComponent,
    SearchBarComponent,
    CartMiniComponent,
  ],
  templateUrl: 'mobile-header.html',
})
export class MobileHeaderComponent {
  @Input() searchQuery: string = '';
  @Output() searchChange = new EventEmitter<string>();
  @Output() toggleSidebar = new EventEmitter<void>();

  readonly menuIcon = MenuIcon;
  readonly searchIcon = SearchIcon;

  onSearchChange(event: any): void {
    this.searchChange.emit(event.target.value);
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
